import * as React from 'react'
import { connect } from 'react-redux'
import { COUNTRY_SHORTCODES } from '../../../constants'
import { applicationCountrySelector } from '../../../selectors'
import { DefaultNamesEntryForm } from './default'
import { JPNamesEntryForm } from './japan'

type Props = {
  fields: { [k: string]: string }
  handleChange: (name: string, value: string) => void
  selectedApplicationCountry: { [k: string]: boolean }
  middleNameInputDisabled: boolean
  toggleMiddleName: () => void
  experiments?: object
}

export class NamesEntryForm extends React.Component<Props> {
  public static defaultProps = {
    fields: {},
    handleChange: () => {},
    selectedApplicationCountry: COUNTRY_SHORTCODES.US,
    middleNameInputDisabled: false,
    toggleMiddleName: () => {},
  }

  public render() {
    const {
      selectedApplicationCountry,
      middleNameInputDisabled,
      toggleMiddleName,
      fields,
      handleChange,
      experiments,
    } = this.props

    return (
      <React.Fragment>
        {selectedApplicationCountry.isJP ? (
          <JPNamesEntryForm fields={fields} handleChange={handleChange} />
        ) : (
          <DefaultNamesEntryForm
            fields={fields}
            handleChange={handleChange}
            middleNameInputDisabled={middleNameInputDisabled}
            toggleMiddleName={toggleMiddleName}
            experiments={experiments}
          />
        )}
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({
  selectedApplicationCountry: applicationCountrySelector(state),
  experiments: state.experiments,
})

export default connect(mapStateToProps)(NamesEntryForm)
